import { NgModule } from '@angular/core';
import { FilterByPipe } from './filter-by.pipe';
import { GroupByPipe } from './group-by.pipe';
import { SortByPipe } from './sort-by.pipe';
import { LanguageSuffixPipe } from './language-suffix.pipe';

const COMMON_PIPES = [
  GroupByPipe,
  FilterByPipe,
  SortByPipe,
  LanguageSuffixPipe,
];

@NgModule({
  declarations: [...COMMON_PIPES, LanguageSuffixPipe],
  exports: [...COMMON_PIPES],
})
export class PipesModule {}
